import { useRef } from "react";
import { useQuery } from "@tanstack/react-query";
import Spinner from "../Shared/Spinner";
import { GetAllBooks } from "../../api/Books/GetAllBooks";
import BooksCarousel from './BooksCarousel';
import courses from "../../assets/Courses.jpg";
import { MoveLeft } from "lucide-react";
const BooksSection = () => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const { data: BooksResponse, isLoading: isBookLoading } = useQuery({
    queryFn: GetAllBooks,
    queryKey: ["books"],
    staleTime: 0,
    refetchInterval: 0,
  });
  const books = BooksResponse?.data?.bookData || [];

  return (
    <div className="sm:mb-40 mb-20 pb-40">
      <div className="md:h-[690px] h-[600px] w-full relative">
        <div className="bg-gradientBg opacity-70 absolute inset-0 z-10 size-full" />
        <div className="absolute inset-0 h-full w-full">
          <img
            src={courses}
            className="h-full w-full object-cover object-top"
            alt=""
          />
        </div>
        <div className="container">
          <div className="relative z-50 sm:space-y-5 space-y-2.5 text-center text-white pt-20">
            <h1 className="font-semibold sm:text-base text-sm">Get Now!</h1>
            <h2 className="md:text-4xl sm:text-3xl text-2xl max-w-[370px] font-semibold mx-auto">
            Our Books
            </h2>
            <p className="max-w-[764px] mx-auto sm:text-base text-sm">
              Take the next step in your career and gain the skills you need to
              succeed. Our courses are designed to empower you with practical
              knowledge and real-world expertise. Join us and start your journey
              today!
            </p>
          </div>
          <div className="relative z-50 sm:mt-16 mt-12">
            {isBookLoading ? (
              <div className="min-h-[50vh] flex items-center justify-center">
                <Spinner />
              </div>
            ) : books.length > 0 ? (
              <BooksCarousel
                books={books}
                prevRef={prevRef}
                nextRef={nextRef}
              />
            ) : (
              <div className="text-center my-10">
                <h2 className="text-lg text-burntBlack">No Books available.</h2>
              </div>
            )}
            <div className="flex justify-center mx-auto sm:gap-5 gap-2.5 items-center sm:mt-7 mt-5 w-full mb-20">
              <button ref={prevRef} className="hover:bg-secondary transition-all duration-300 bg-white border border-secondary text-white flex items-center justify-center sm:size-[55px] size-12 rounded-full group">
                <MoveLeft
                  className="text-secondary group-hover:text-white sm:w-8 w-6"
                  size={32}
                />
              </button>
              <button ref={nextRef} className="hover:bg-secondary transition-all duration-300 bg-white border border-secondary text-white flex items-center justify-center sm:size-[55px] size-12 rounded-full group">
                <MoveLeft
                  className="rotate-180 text-secondary group-hover:text-white sm:w-8 w-6"
                  size={32}
                />
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>

  );
};

export default BooksSection;
